import * as React from "react";
import GeneralSelect from "../../general_select";
import PopDetail from "../../popdetail";
import PopBig from "../../popbig";
import {ProjectsService} from "../../../service/v1/projects";
import AddNewFunderPane from "./add_new_funder_pane";
import CreateService from "../../../service/create";

export default class AddNewProjectPane extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            project_type: {value: 0},
            project_funder: [],
            project_existence: {
                endpoint: 'setup/project-existence',
                value: 'id',
                placeholder: 'Select existence',
                label: 'name'
            },
            description: '',
            zoneOptions: {endpoint: 'localities/list', value: 'id', label: 'name', placeholder: 'Select Zone'},
            regionOptions: {endpoint: 'localities/list', value: 'id', label: 'name', placeholder: 'Select Region'},
            districtOptions: {
                endpoint: 'localities/list',
                value: 'id',
                label: 'name',
                placeholder: 'Select District'
            },
            wardOptions: {
                endpoint: 'localities/list',
                value: 'id',
                label: 'name',
                placeholder: 'Select Ward'
            },
            villageOptions: {
                endpoint: `localities/list`,
                value: 'id',
                label: 'name',
                placeholder: 'Select Village'
            },
            projectOptions: {
                endpoint: `projects/project-types`,
                value: 'id',
                label: 'name',
                placeholder: 'Select Project'
            },
            projectFunder: {endpoint: `setup/funders`, value: 'id', label: 'name', placeholder: 'Select Funder/s'},
            is_new: 'none',
            is_village: 'none',
            is_ward: 'none',
            is_district: 'none',
            is_regional: 'none',
            is_zonal: 'none',
            is_village_multi: true,
            is_ward_multi: true,
            is_district_multi: true,
            is_regional_multi: true,
            is_zonal_multi: true,
            is_village_disabled: true,
            is_ward_disabled: true,
            is_district_disabled: true,
            is_regional_disabled: true,
            locality: '',
            project_list: {
                endpoint: 'projects/list',
                value: 'id',
                placeholder: 'Select Project',
                label: 'name'
            },
            showFunderForm: false,
            newFunderType: null,
            newFunderName: ''
        }

        this.submit = this.submit.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
        this.generalSelect = this.generalSelect.bind(this)
        this.refreshFunders = this.refreshFunders.bind(this)
        this.toggleFunderForm = this.toggleFunderForm.bind(this)
        this.handleFunderFormChange = this.handleFunderFormChange.bind(this)
        this.handleFunderTypeSelect = this.handleFunderTypeSelect.bind(this)
        this.saveNewFunder = this.saveNewFunder.bind(this)
    }

    refreshFunders() {
        // Refresh the funder list by updating the projectFunder state
        this.setState({
            projectFunder: {
                endpoint: 'setup/funders',
                value: 'id',
                label: 'name',
                placeholder: 'Select Project Funders'
            }
        });
    }

    toggleFunderForm() {
        this.setState(prevState => ({
            showFunderForm: !prevState.showFunderForm
        }));
    }

    handleFunderFormChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    handleFunderTypeSelect(data) {
        this.setState({
            newFunderType: data
        });
    }

    saveNewFunder() {
        if (!this.state.newFunderType || !this.state.newFunderName.trim()) {
            alert('Please fill in all required fields');
            return;
        }
        
        const payload = {
            type: this.state.newFunderType.value,
            name: this.state.newFunderName.toLowerCase(),
            category: this.state.newFunderType.value
        };

        CreateService.createFunder(payload)
            .then(() => {
                // Reset form and hide it
                this.setState({
                    showFunderForm: false,
                    newFunderType: null,
                    newFunderName: ''
                });

                // Refresh the funder list
                this.refreshFunders();
            })
            .catch(e => {
                alert('Error creating funder: ' + (e.response?.data?.category?.[0] || e.message));
            });
    }

    handleChanges = (e) => {
        this.setState({[e.target.name]: e.target.value})

        console.log(e.target.name)

        if (e.target.name === 'project') {
            if (e.target.value === 'existing') {
                this.setState({
                    is_new: 'table-row'
                })
            } else {
                this.setState({
                    is_new: 'none'
                })
            }
        }
    }

    generalSelect(data, name) {
        this.setState({
            [name]: data
        })
        console.log(this.state[name])
        console.log("dv : " + data.value)
        let ids = []

        switch (name) {
            case 'zone':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_regional_disabled: false,
                    regionOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id') + '&parent_id='+data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select Region'
                    }
                })
                break;
            case 'region':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_district_disabled: false,
                    districtOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('district_level_id') + '&parent_id='+data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select District'
                    }
                })
                break
            case 'district':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_ward_disabled: false,
                    wardOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('ward_level_id') + '&parent_id='+data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select Ward'
                    }
                })
                break
            case 'ward':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_village_disabled: false,
                    villageOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('village_level_id') + '&parent_id='+data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select Village'
                    }
                })
                break
            case 'project_existence':
                if (data.value === 'existing') {
                    this.setState({
                        is_new: 'table-row'
                    })
                } else {
                    this.setState({
                        is_new: 'none'
                    })
                }

                break

            case 'project_list':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                    this.setState({
                        villageOptions: {
                            endpoint: `projects/list`,
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Project'
                        }
                    })
                }
                break
            case 'project_type':
                if (data.label.toString().includes('Village') || data.label.toString().includes('CCRO')
                    || data.label.toString().toLowerCase().includes('formal')) {
                    this.setState({
                        is_village: 'table-row',
                        is_ward: 'table-row',
                        is_district: 'table-row',
                        is_ward_multi: false,
                        is_district_multi: false,
                        is_regional_multi: false,
                        is_regional: 'table-row',
                        is_zonal: 'none',
                        regionOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Region'
                        },
                        is_regional_disabled: false,
                        locality: 'Village'
                    })
                }
                if (data.label.toString().includes('District')) {
                    this.setState({
                        is_village: 'none',
                        is_ward: 'none',
                        is_district: 'table-row',
                        is_regional: 'table-row',
                        is_regional_multi: false,
                        is_zonal: 'none',
                        regionOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Region'
                        },
                        is_regional_disabled: false,
                        locality: 'District'
                    })
                }
                if (data.label.toString().includes('Region')) {
                    this.setState({
                        is_village: 'none',
                        is_ward: 'none',
                        is_district: 'none',
                        is_regional: 'table-row',
                        is_zonal: 'table-row',
                        zoneOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('zonal_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Zone'
                        },
                        is_zonal_multi: false,
                        locality: 'Regional'
                    })
                }
                if (data.label.toString().includes('Zon')) {
                    this.setState({
                        is_village: 'none',
                        is_ward: 'none',
                        is_district: 'none',
                        is_regional: 'none',
                        is_zonal: 'table-row',
                        locality: 'Zonal',
                        zoneOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('zonal_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Zone'
                        },
                    })
                }
                if (data.label.toString().includes('Monitor')) {
                    this.setState({
                        is_village: 'none',
                        is_ward: 'none',
                        is_district: 'none',
                        is_regional: 'none',
                        is_zonal: 'table-row',
                        locality: 'Monitoring',
                        zoneOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('zonal_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Zone'
                        },
                    })
                }
                if (data.label.toString().includes('Nation')) {
                    this.setState({
                        locality: 'National',
                    })
                }
                break
        }
    }

    render() {

        return (<div className={'row'}>

            <div className={'col col-sm-12'} style={{padding: 0, height: '70vh', overflow: "auto"}}>

                <div style={{
                    padding: '16px',
                    background: '#efefef',
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    display: 'none'
                }}>
                     <span style={{fontSize: '16px'}}>
                        <span className={'fa fa-users'} style={{marginRight: '8px'}}/>
                        Project Registration
                    </span>

                    <span style={{fontSize: '12px', float: 'right'}}>
                        <span className={'fa fa-history'} style={{marginRight: '11px', marginLeft: '4px'}}/>Updated 28 Minutes Ago
                    </span>

                </div>

                <table style={{width: '94%', margin: '2%'}}>
                    <tbody>
                    <tr>
                        <td className={'label'} style={{width: '100%'}}>Project Type</td>
                    </tr>
                    <tr>
                        <td>
                            <GeneralSelect onChanges={(e) => this.generalSelect(e, 'project_type')}
                                           parameters={this.state.projectOptions}/>
                        </td>
                    </tr>

                    <tr>
                        <td className={'label'} style={{width: '100%'}}>Project name</td>
                    </tr>
                    <tr>
                        <td>
                            <input type={'text'} style={{width: '99%', padding: '8px'}} name={'name'}
                                   onChange={this.handleChanges}/>
                        </td>
                    </tr>
                    <tr>
                        <td className={'label'}>Description</td>
                    </tr>
                    <tr>
                        <td>
                            <textarea rows={3} style={{width: '100%'}} name={'description'}
                                      onChange={this.handleChanges}/>
                        </td>
                    </tr>

                    <tr>
                        <td style={{width: '100%'}}>
                            <table style={{width: '100%'}}>
                                <tbody>

                                <tr>
                                    <td className={'label'}>Project Funders</td>
                                    <td className={'label'}>Project Budget</td>
                                    <td className={'label'}>Project Existence</td>
                                </tr>
                                <tr>
                                    <td>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <div style={{ flex: 1 }}>
                                        <GeneralSelect onChanges={(e) => this.generalSelect(e, 'project_funder')}
                                                       parameters={this.state.projectFunder} isMulti={true}/>
                                            </div>
                                            <button 
                                                type="button"
                                                className="fa fa-plus"
                                                style={{
                                                    fontSize: '16px',
                                                    cursor: 'pointer',
                                                    background: 'darkcyan',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    padding: '8px 12px',
                                                    minWidth: '40px',
                                                    height: '38px'
                                                }}
                                                onClick={this.toggleFunderForm}
                                                title="Add New Funder"
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <input type={'number'} onChange={this.handleChanges}
                                               style={{width: '90%', padding: '10px'}} name={'budget'}/>
                                    </td>
                                    <td>
                                        <GeneralSelect onChanges={(e) => this.generalSelect(e, 'project_existence')}
                                                       parameters={this.state.project_existence} isMulti={false}/>
                                    </td>
                                </tr>

                                {/* Inline Funder Form */}
                                {this.state.showFunderForm && (
                                    <tr>
                                        <td colSpan={3}>
                                            <div style={{ 
                                                border: '1px solid #ddd', 
                                                borderRadius: '4px', 
                                                padding: '12px', 
                                                marginTop: '8px',
                                                backgroundColor: '#f9f9f9'
                                            }}>
                                                <h5 style={{ margin: '0 0 12px 0', color: '#395d9a' }}>Add New Funder</h5>
                                                <table style={{ width: '100%' }}>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ width: '50%', paddingRight: '8px' }}>
                                                                <div className={'label'}>Funder Type *</div>
                                                                <select 
                                                                    onChange={(e) => this.handleFunderTypeSelect({value: e.target.value, label: e.target.options[e.target.selectedIndex].text})}
                                                                    style={{ 
                                                                        width: '100%', 
                                                                        padding: '8px',
                                                                        border: '1px solid #ccc',
                                                                        borderRadius: '4px'
                                                                    }}
                                                                    defaultValue=""
                                                                >
                                                                    <option value="" disabled style={{ backgroundColor: '#f5f5f5' }}>Select Funder Type</option>
                                                                    <option value="government" style={{ backgroundColor: '#f5f5f5' }}>Government</option>
                                                                    <option value="non-government" style={{ backgroundColor: '#f5f5f5' }}>Non-Government</option>
                                                                </select>
                                                                <style>{`
                                                                    select option:hover {
                                                                        background-color: #dddddd !important;
                                                                    }
                                                                    select option:checked {
                                                                        background-color: #395d9a !important;
                                                                        color: white !important;
                                                                    }
                                                                `}</style>
                                                            </td>
                                                            <td style={{ width: '50%', paddingLeft: '8px' }}>
                                                                <div className={'label'}>Funder Name *</div>
                                                                <input 
                                                                    type={'text'} 
                                                                    name={'newFunderName'}
                                                                    value={this.state.newFunderName}
                                                                    onChange={this.handleFunderFormChange}
                                                                    style={{ width: '100%', padding: '8px' }}
                                                                    placeholder="Enter funder name"
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div style={{ textAlign: 'right', marginTop: '12px' }}>
                                                    <button className={'btn submit'} onClick={this.saveNewFunder} style={{ marginRight: '8px' }}>
                                                        <span className={'fa fa-save'}/>Save Funder
                                                    </button>
                                                    <button className={'btn error'} onClick={this.toggleFunderForm}>
                                                        <span className={'fa fa-times'}/>Cancel
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )}

                                <tr style={{display: this.state.is_new}}>
                                    <td colSpan={2} className={'label'}>Registration Date</td>
                                    <td colSpan={2} className={'label'}>Authorization
                                        Date
                                    </td>
                                </tr>
                                <tr style={{display: this.state.is_new}}>
                                    <td colSpan={2}>
                                        <input type={'date'} style={{width: '90%', padding: '8px'}} name={'reg_date'}
                                               onChange={this.handleChanges}/>
                                    </td>
                                    <td colSpan={2}>
                                        <input type={'date'} style={{width: '100%'}}
                                               name={'auth_date'} onChange={this.handleChanges}/>
                                    </td>
                                </tr>

                                <tr style={{display: this.state.is_zonal}}>
                                    <td colSpan={2} className={'label'}>Zone</td>
                                </tr>
                                <tr style={{display: this.state.is_zonal}}>
                                    <td colSpan={2}>
                                        <GeneralSelect onChanges={(e) => this.generalSelect(e, 'zone')}
                                                       parameters={this.state.zoneOptions}
                                                       isMulti={this.state.is_zonal_multi}/>
                                    </td>
                                </tr>
                                <tr style={{display: this.state.is_regional}}>
                                    <td colSpan={2} className={'label'}>Regions</td>
                                </tr>
                                <tr style={{display: this.state.is_regional}}>
                                    <td colSpan={2}>
                                        <GeneralSelect onChanges={(e) => this.generalSelect(e, 'region')}
                                                       parameters={this.state.regionOptions}
                                                       isMulti={this.state.is_regional_multi}
                                                       isDisable={this.state.is_regional_disabled}/>
                                    </td>
                                </tr>
                                <tr style={{display: this.state.is_district}}>
                                    <td colSpan={2} className={'label'}>District/Council</td>
                                </tr>
                                <tr style={{display: this.state.is_district}}>
                                    <td colSpan={2}>
                                        <GeneralSelect onChanges={(e) => this.generalSelect(e, 'district')}
                                                       parameters={this.state.districtOptions}
                                                       isMulti={this.state.is_district_multi}
                                                       isDisable={this.state.is_district_disabled}/>
                                    </td>
                                </tr>

                                <tr style={{display: this.state.is_ward}}>
                                    <td colSpan={2} className={'label'}>Ward</td>
                                </tr>
                                <tr style={{display: this.state.is_ward}}>
                                    <td colSpan={2}>
                                        <GeneralSelect onChanges={(e) => this.generalSelect(e, 'ward')}
                                                       parameters={this.state.wardOptions}
                                                       isMulti={this.state.is_ward_multi}
                                                       isDisable={this.state.is_ward_disabled}/>
                                    </td>
                                </tr>

                                <tr style={{display: this.state.is_village}}>
                                    <td colSpan={2} className={'label'}>Villages</td>
                                </tr>
                                <tr style={{display: this.state.is_village}}>
                                    <td colSpan={2}>
                                        <GeneralSelect onChanges={(e) => this.generalSelect(e, 'village')}
                                                       parameters={this.state.villageOptions}
                                                       isMulti={this.state.is_village_multi}
                                                       isDisable={this.state.is_village_disabled}/>
                                    </td>
                                </tr>

                                </tbody>
                            </table>

                        </td>

                    </tr>

                    </tbody>
                </table>

                <div style={{textAlign: 'center', width: '100%', float: 'left'}}>
                    <button className={'btn submit'} onClick={this.submit}>
                        <span className={'fa fa-save'}/>Create Project
                    </button>
                </div>

            </div>

        </div>)
    }

    submit() {
        try {
            let name = this.state.name
            let desc = this.state.description
            let project_type = this.state.project_type.value
            let project = this.state.project_existence.value
            let budget = this.state.budget
            let auth_date = this.state.auth_date

            let project_funder = []
            let locality = []
            
            switch (this.state.locality) {
                case 'Village':
                    this.state.village.forEach(it => {
                        locality.push(it.value)
                    })
                    break
                case 'District':
                    this.state.district.forEach(it => {
                        locality.push(it.value)
                    })
                    break
                case 'Regional':
                    this.state.region.forEach(it => {
                        locality.push(it.value)
                    })
                    break
                case 'Zonal':
                    this.state.zone.forEach(it => {
                        locality.push(it.value)
                    })
                    break
                case 'National':
                    locality.push(sessionStorage.getItem('national_level_id'))
                    break
                default:
                    this.state.zone.forEach(it => {
                        locality.push(it.value)
                    })
            }

            this.state.project_funder.forEach(it => {
                project_funder.push(it.value)
            })

            ProjectsService.createProject({
                name: name,
                description: desc,
                locality_ids: locality,
                project_type: project_type,
                project: project,
                funder_ids: project_funder,
                budget: budget,
                reg_date: '',
                auth_date: auth_date
            }).then(r => {
                this.props.loadProjects()
                PopDetail.dismiss()
            })

        } catch (e) {
            alert(e)
        }
    }

// restored to its original version

}